import { httpClient } from '~/lib/http-client'
import type {
  CreateFederationRequest,
  Federation,
  UpdateFederationRequest,
} from '~/types/federation'

/**
 * Lista todas as federações aprovadas publicamente (para página de registro)
 */
export async function listFederationsPublic() {
  return httpClient.get<Federation[]>('/federacoes/public', { useAuth: false })
}

/**
 * Lista todas as federações
 */
export async function listFederations() {
  return httpClient.get<Federation[]>('/federacoes', { useAuth: true })
}

/**
 * Obtém uma federação específica
 */
export async function getFederation(id: number) {
  return httpClient.get<Federation>(`/federacoes/${id}`, { useAuth: true })
}

/**
 * Cria uma nova federação
 */
export async function createFederation(data: CreateFederationRequest) {
  return httpClient.post<{ message: string; federacao: Federation }>(
    '/federacoes',
    { ...data },
    { useAuth: true }
  )
}

/**
 * Atualiza uma federação
 */
export async function updateFederation(
  id: number,
  data: UpdateFederationRequest
) {
  return httpClient.put<{ message: string; federacao: Federation }>(
    `/federacoes/${id}`,
    { ...data },
    { useAuth: true }
  )
}

/**
 * Exclui uma federação
 */
export async function deleteFederation(id: number) {
  return httpClient.delete<{ message: string }>(`/federacoes/${id}`, {
    useAuth: true,
  })
}
